import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Club, User} from 'packages/common-types/schema-types';
import useAppDispatch from 'packages/hooks/use-app-dispatch';
import useAppSelector from 'packages/hooks/use-app-selector';
import useCommonStyles from 'packages/common-utils/common-styles';
import {useEffect, useState} from 'react';
import {
  addPlayerToGroup,
  selectPlayersToGroup,
  removePlayerFromGroup,
} from 'redux/features/app-slice';
import {Divider, Typography} from '@material-ui/core';
import useStyles from 'packages/admin/groups/groups.styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import {renderAddress} from 'packages/common-utils/helpers';
import {GET_CLUBS} from 'packages/graphql/v2/queries';
import {useQuery} from '@apollo/client';

type Props = {
  dataPlayers: User[];
};

type GetClubsData = {
  getClubs: Club[];
};

const AutocompletePlayers = (props: Props) => {
  const {dataPlayers} = props;
  const common = useCommonStyles();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const playersToGroup = useAppSelector(selectPlayersToGroup);
  const [value, setValue] = useState<User | null>(null);
  const [players, setPlayers] = useState([]);
  const {data: registeredClubs} = useQuery<GetClubsData>(GET_CLUBS);

  useEffect(() => {
    if (playersToGroup) {
      setPlayers(
        dataPlayers.filter(({uid}) => {
          return !playersToGroup.find((player) => uid === player.uid);
        })
      );
    } else {
      setPlayers(dataPlayers);
    }
  }, [dataPlayers, playersToGroup]);

  const handleAddPlayersToNewGroup = () => {
    if (playersToGroup) {
      setPlayers(players.filter(({uid}) => uid !== value.uid));
      setValue(null);
      dispatch(addPlayerToGroup(value));
    }
  };

  const handleDeleteMember = (idsToGroup: String[], idToDelete: string) => {
    setPlayers(
      dataPlayers.filter(({uid}) => {
        return !idsToGroup.find((id) => id === uid);
      })
    );
    dispatch(removePlayerFromGroup(idToDelete));
  };

  return (
    <>
      <div className={common.grid_searchbar_button}>
        <Autocomplete
          id="combo-box-demo"
          options={players || []}
          noOptionsText="Sin jugadores para agrupar."
          onChange={(_: any, newValue: any) => {
            setValue(newValue);
          }}
          value={value}
          getOptionLabel={(option) => option.fullName}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              placeholder="Jugadores inscrítos"
              label="Jugadores"
              variant="outlined"
            />
          )}
        />
        <div style={{marginLeft: 16}}>
          <Button
            onClick={handleAddPlayersToNewGroup}
            className={common.custom_button}
            variant="contained"
            color="secondary"
            disableElevation
          >
            Añadir
          </Button>
        </div>
      </div>
      <Typography variant="h6">Miembros</Typography>
      <Divider />
      <div className={classes.group_members_list_container}>
        <List dense>
          {playersToGroup?.map(({uid, fullName, address, clubId}) => {
            const labelId = `checkbox-list-secondary-label-${uid}`;
            const clubName = registeredClubs?.getClubs?.find(
              ({_id}) => _id === clubId
            )?.name;
            return (
              <ListItem key={uid}>
                <ListItemAvatar>
                  <Avatar alt={`Avatar ${fullName}`}>
                    {fullName?.split('')[0]}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  id={labelId}
                  primary={`${fullName}`}
                  secondary={`${renderAddress(address)}, ${
                    clubName || 'Sin club'
                  }`}
                />
                <ListItemSecondaryAction
                  onClick={() =>
                    handleDeleteMember(
                      playersToGroup
                        .filter((player) => uid !== player.uid)
                        .map(({uid}) => uid),
                      uid
                    )
                  }
                >
                  <IconButton color="default" component="span">
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </div>
    </>
  );
};

export default AutocompletePlayers;
